import React from 'react';
import { Card, CardContent, Typography, Box, useTheme } from '@mui/material';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';
import { UserGrowth } from '../../../app/network/api/dashboard';

interface UserGrowthChartProps {
    data: UserGrowth[];
    loading?: boolean;
}

const UserGrowthChart: React.FC<UserGrowthChartProps> = ({ data, loading }) => {
    const theme = useTheme();

    if (loading) {
        return (
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        사용자 성장 추이
                    </Typography>
                    <Box sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Typography color="text.secondary">로딩 중...</Typography>
                    </Box>
                </CardContent>
            </Card>
        );
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    사용자 성장 추이
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
                        <XAxis
                            dataKey="date"
                            stroke={theme.palette.text.secondary}
                            style={{ fontSize: 12 }}
                            tickFormatter={(value) => {
                                const date = new Date(value);
                                return `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
                            }}
                        />
                        <YAxis stroke={theme.palette.text.secondary} style={{ fontSize: 12 }} />
                        <Tooltip
                            contentStyle={{
                                backgroundColor: theme.palette.background.paper,
                                border: `1px solid ${theme.palette.divider}`,
                                borderRadius: 4,
                            }}
                        />
                        <Legend />
                        <Line
                            type="monotone"
                            dataKey="newUsers"
                            name="신규 사용자"
                            stroke={theme.palette.primary.main}
                            strokeWidth={2}
                            dot={{ fill: theme.palette.primary.main, r: 4 }}
                            activeDot={{ r: 6 }}
                        />
                        <Line
                            type="monotone"
                            dataKey="cumulativeUsers"
                            name="누적 사용자"
                            stroke={theme.palette.success.main}
                            strokeWidth={2}
                            dot={{ fill: theme.palette.success.main, r: 4 }}
                            activeDot={{ r: 6 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
};

export default UserGrowthChart;
